import * as canvasBlocksActionTypes from '../../constants/actionTypes/canvasBlocks';
import * as columnActionTypes from '../../constants/actionTypes/column';
import * as columnItemActionTypes from '../../constants/actionTypes/columnItem';

const initialState = '';

const capturedActions = {
    // UNDO / REDO
    '@@redux-undo/UNDO': 'pressed undo button.',
    '@@redux-undo/REDO': 'pressed redo button.',
    // BLOCKS
    [canvasBlocksActionTypes.SWITCH_LOCK_STRUCTURE]: 'Block lock structure was switched.',
    [canvasBlocksActionTypes.ADD_BLOCK]: 'A new block was added.',
    [canvasBlocksActionTypes.DUPLICATE_BLOCKS]: 'A block was duplicated.',
    [canvasBlocksActionTypes.REMOVE_BLOCK]: 'A block was removed.',
    [canvasBlocksActionTypes.MOVE_BLOCKS]: 'A block was moved up or down.',
    [canvasBlocksActionTypes.SWAP_BLOCKS]: 'A block position was changed.',
    [canvasBlocksActionTypes.DELETE_BLOCKS]: 'A block was deleted.',
    [canvasBlocksActionTypes.LOCK_BLOCKS]: 'Block(s) were locked.',
    [canvasBlocksActionTypes.UPDATE_BLOCKS_PROPERTIES]: 'Block(s) property got updated.',
    // COLUMNS
    [columnActionTypes.MERGE_COLUMN]: 'Block column and their elements were merged into another column.',
    [columnActionTypes.MOVE_COLUMN]: 'Block column and their elements were moved.',
    [columnActionTypes.SPLIT_COLUMN]: 'Block column and their elements were split in half into two columns.',
    // COLUMN ITEM
    [columnItemActionTypes.UPDATE_COLUMN_ITEM_CONTENT]: 'Element content got updated',
    [columnItemActionTypes.ADD_NEW_ITEM_FROM_PLACEHOLDER_TO_COLUMN]:
        'An element was added from the toolbox element collection into a block.',
    [columnItemActionTypes.MOVE_COLUMN_ITEM_CONTENT_TO_ANOTHER_COLUMN]:
        'An element was switched its position to a different place.',
    [columnItemActionTypes.DUPLICATE_COLUMN_ITEM]: 'An element was duplicated.',
    [columnItemActionTypes.DELETE_COLUMN_ITEM]: 'An element was deleted.',
    [columnItemActionTypes.ADD_NEW_COLUMN_ITEM]:
        'A new element was dragged from the toolbox elements and was dropped into a block.',
};

const changeLog = (state = initialState, action) => {
    if (Object.keys(capturedActions).includes(action.type)) {
        return capturedActions[action.type];
    }
    return state;
};

export default changeLog;
